module.exports = __webpack_public_path__ + "static/img/SFG128-BT.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/SFG128-BT.png
// module id = gMH3
// module chunks = 0